const scriptURL = 'https://script.google.com/macros/s/AKfycbxTLBJPzGFqYno748v2LGvwrPRtPWp0NSoRtdfUFm7CM74NPRFzcR8swRhuG5EID-NqXg/exec';

document.addEventListener("DOMContentLoaded", () => {
  console.log('adentro de emailpop')
  const emailPopup = document.getElementById("email-popup");
  const emailForm = document.getElementById("email-form");  
  const statusMessage = document.getElementById("status-message");
  const emailTitle = document.getElementById("email-popup-heading")
  const returnStore = document.getElementById("returnStore");

  emailForm.addEventListener("submit", event => {
    event.preventDefault();
    
    const emailInput = document.getElementById("user-email");
    const email = emailInput.value.trim();
    if (email) {
      // Hide the form and title
      emailForm.style.display = "none";
      emailTitle.style.display = "none";
      returnStore.style.display = "none";
      
      // Show the loading message
      // statusMessage.textContent = "Submitting your email...";
      statusMessage.style.display = "block";
      console.log("aaabout to submit");
      
      fetch(scriptURL, {
        method: 'POST',
        cache: "no-cache",
        redirect: "follow",
        body: JSON.stringify({ type: "emailSubmission", email: email }),
        headers: { "Content-Type": "text/plain;charset=utf-8" }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // Parse response JSON
        })
        .then(data => {
          console.log("Server response:", data);
          if (data.status === "success") {
            emailPopup.classList.add("hidden");
                       
        } else {
          statusMessage.style.display = "none"; // Hide the "submitting" message
          emailForm.style.display = "block"; // Show the form again
          emailTitle.style.display = "block";
          returnStore.style.display = "block";
          alert(data.message || "An error occurred.");
        }
      })
    .catch(error => console.error("Error:", error));
    } else {
      alert("Please enter a valid email address.");
    }
  });
});